export default __webpack_public_path__ + "static/media/delete-icon.9909a444.svg";